import { useEffect } from 'react';
import { onLCP, LCPMetricWithAttribution } from 'web-vitals/attribution';
import { getFaro } from '@/client/components/GrafanaFaro';
import { WebVitalsLabProps } from '../shared';

const sendBeacon = (pageName: string, data: LCPMetricWithAttribution) => {
  const { id, value, rating } = data;
  const { target, resourceLoadDuration, elementRenderDelay } = data.attribution;

  const values = {
    value,
    resourceLoadDuration,
    elementRenderDelay,
  };
  const beacon = {
    id,
    pageName,
    rating,
    target: `${target}`,
  };
  console.log(
    `%cINP-LAB track ${value} ${value} ${JSON.stringify(beacon)}`,
    'background: #222; color: #bada55'
  );

  getFaro().api.pushMeasurement(
    {
      type: 'LCP-LAB',
      values,
    },
    {
      context: beacon,
    }
  );
};

const shouldSend = (data: LCPMetricWithAttribution): boolean => {
  return ['poor', 'needs-improvement'].includes(data.rating);
};

const LcpTracker = ({ pageName }: WebVitalsLabProps): undefined => {
  useEffect(() => {
    console.log('%cLCP-LAB active', 'background: #222; color: #bada55');
    onLCP((data: LCPMetricWithAttribution) => {
      if (shouldSend(data)) {
        sendBeacon(pageName, data);
      }
    });
  }, []);
};

export { shouldSend, LcpTracker };
